"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceFields = exports.FIELDS_MAP = void 0;
exports.FIELDS_MAP = {
    id: 'id',
    a: "\u05D3\u05E8\u05D2\u05D4",
    b: "\u05E9\u05DD",
    c: "\u05E9\u05DD \u05DE\u05E9\u05E4\u05D7\u05D4",
    d: "\u05D2\u05D9\u05DC",
    e: "\u05DE\u05D9\u05DF",
    f: "\u05DE\u05D0\u05D9\u05E4\u05D4 \u05D1\u05D0\u05E8\u05E5",
    g: "\u05D0\u05D6\u05E8\u05D7/\u05D7\u05D9\u05D9\u05DC/\u05E9\u05D5\u05D8\u05E8/\u05D4\u05E9\u05D1\"\u05DB",
    h: "subtitle - 1",
    i: "subtitle - final",
    j: "\u05DC\u05D9\u05E0\u05E7 \u05DC\u05EA\u05DE\u05D5\u05E0\u05D4",
    k: 'יחידה',
    l: 'טקסט חופשי',
    date: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05D5\u05E1\u05E4\u05D4 \u05DC\u05D8\u05D5\u05D1\u05EA \u05DE\u05D9\u05D5\u05DF \u05D4\u05EA\u05D5\u05E6\u05D0\u05D5\u05EA \u05DC\u05E4\u05D9 \u05F4\u05D4\u05DB\u05D9 \u05E2\u05D3\u05DB\u05E0\u05D9\u05F4",
    status: "\u05E1\u05D8\u05D8\u05D5\u05E1",
    killed: "\u05E0\u05D4\u05E8\u05D2\u05D5",
    line1: 'משפט 1',
    line2: 'משפט 2',
};
/**
 * a: rank,
 * b: name
 * c: surname
 * d: age,
 * e: sex,
 * f: city,
 * g: role,
 * h: subtitle1,
 * i: subtitleFinal,
 * j: photo,
 * k: unit
 * l: description,
 */
function replaceFields(data) {
    var result = data.map(function (item) {
        var newItem = {};
        Object.entries(item).forEach(function (_a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], value = _c[1];
            var mappedKey = (_b = Object.entries(exports.FIELDS_MAP).find(function (_a) {
                var _b = __read(_a, 2), v = _b[1];
                return v.trim() === key.trim();
            })) === null || _b === void 0 ? void 0 : _b[0];
            if (mappedKey) {
                newItem[mappedKey] = value;
            }
        });
        return newItem;
    });
    return result;
}
exports.replaceFields = replaceFields;
//# sourceMappingURL=replace-fields.js.map